type TAddToQueryParams = {
  newParams: Record<string, string>;
};

const addToQueryParams = ({ newParams }: TAddToQueryParams) => {
  const queryParams = new URLSearchParams(window.location.search);

  for (const [key, value] of Object.entries(newParams)) {
    queryParams.set(key, value);
  }

  const windowHash = window.location.hash || '';

  const newUrl = `${
    window.location.pathname
  }?${queryParams.toString()}${windowHash}`;

  window.history.pushState({ ...newParams }, '', newUrl);
};

export { addToQueryParams };
